"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardHeaderMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
/** @class CardHeaderMixin */
/** @method */
var CardHeaderMixin = function CardHeaderMixin(props) {
  return (0, _styledToken.default)({
    fontType: 'CardHeader.fontType',
    borderColor: 'Card.separatorColor',
    marginTop: 'CardHeader.marginTop',
    marginBottom: 'CardHeader.marginBottom',
    borderBottomWidth: 'CardHeader.borderBottomWidth',
    paddingBottom: 'CardHeader.paddingBottom'
  }, function (_ref) {
    var fontType = _ref.fontType,
      borderColor = _ref.borderColor,
      _ref$marginTop = _ref.marginTop,
      marginTop = _ref$marginTop === void 0 ? 0 : _ref$marginTop,
      marginBottom = _ref.marginBottom,
      _ref$borderBottomWidt = _ref.borderBottomWidth,
      borderBottomWidth = _ref$borderBottomWidt === void 0 ? 1 : _ref$borderBottomWidt,
      paddingBottom = _ref.paddingBottom;
    return (0, _styledComponents.css)(["", " padding-bottom:", ";border-bottom:", "px solid ", ";margin-top:", "px;margin-bottom:", ";", ""], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), paddingBottom ? paddingBottom + "px" : (0, _spaceMixin.spaceMixin)('sm')(props), borderBottomWidth, borderColor, marginTop, marginBottom ? marginBottom + "px" : (0, _spaceMixin.spaceMixin)('md')(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.CardHeaderMixin = CardHeaderMixin;